import React from 'react';

export const EditIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/edit' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='fe:edit' transform='translate(3.000000, 3.000000)'>
          <rect id='ViewBox' x='0' y='0' width='24' height='24'></rect>
          <path
            d='M5,20 L19,20 C19.5522847,20 20,20.4477153 20,21 C20,21.5522847 19.5522847,22 19,22 L5,22 C4.44771525,22 4,21.5522847 4,21 C4,20.4477153 4.44771525,20 5,20 Z M4,15 L14,5 L17,8 L7,18 L4,18 L4,15 Z M15,4 L17,2 L20,5 L17.999,7.001 L15,4 Z'
            id='Shape'
            fill='currentColor'
          ></path>
        </g>
      </g>
    </svg>
  );
};
